import React from "react";
import { withStyles } from "@material-ui/styles";
import Header from "../components/molecules/header";
import Footer from "../components/molecules/footer";
const styles = theme => ({
  root: {
    flex: "1 1 100%",
    maxWidth: "1500px",
    margin: "0 auto",
    backgroundColor: "white"
  },
  container: {
    flex: "1 1 100%",
    maxWidth: "960px",
    margin: "0 auto",
    minHeight: "800px"
  }
});

class PageLayout extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Header />
        <div className={classes.container}>{this.props.children}</div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles)(PageLayout);
